<template>
  <VModal ref="dialog" disable-backdrop-click @close="$emit('close')">
    <template #default="modalProps">
      <div class="rounded shadow-xs w-full max-w-full h-full mx-auto">
        <div class="rounded shadow-lg bg-gray-100 overflow-hidden h-full flex flex-col">
          <div class="px-4 sm:px-6 py-5 border-b flex-none">
            <div class="flex items-center justify-between">
              <div class="flex-1">
                <h1 class="text-sm">Add Product</h1>
              </div>

              <div class="flex-none">
                <button
                  type="button"
                  class="rounded-md text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                  @click="modalProps.close"
                >
                  <span class="sr-only">Close</span>
                  <svg
                    class="inline-flex h-6 w-6"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    aria-hidden="true"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M6 18L18 6M6 6l12 12"
                    />
                  </svg>
                </button>
              </div>
            </div>
          </div>
          <div class="flex-1 bg-white overflow-auto flex">
            <div v-if="!currentComponent" class="p-12 mx-auto self-center">
              <div class="flex gap-4">
                <BaseButton primary @click="currentComponent = 'SelectProduct'"
                  >Select from existing</BaseButton
                >
                <BaseButton secondary @click="currentComponent = 'BuildNewProduct'"
                  >Create custom</BaseButton
                >
              </div>
            </div>
            <ProductSelector
              v-else-if="currentComponent === 'SelectProduct'"
              @select="handleSelect"
              @back="currentComponent = null"
            />
            <ProductBuilder
              v-else-if="currentComponent === 'BuildNewProduct'"
              @select="handleSelect"
              @back="currentComponent = null"
            />
          </div>
        </div>
      </div>
    </template>
  </VModal>
</template>

<script>
import orderLinesMixin from '@/mixins/orderLinesMixin';
import ProductSelector from './ProductSelector.vue';
import ProductBuilder from './ProductBuilder.vue';

export default {
  mixins: [orderLinesMixin],
  components: { ProductSelector, ProductBuilder },
  data() {
    return {
      currentComponent: null,
    };
  },
  methods: {
    handleSelect(product) {
      this.createOrderLineFromMembership(product);
      this.$emit('add', [...this.orderLines]);
      this.$refs.dialog.close();
    },
  },
};
</script>
